











import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import {Icon} from "@/helpers/icons";
import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import BillUpdateDialogAdditionalInfos from "@/components/bill/BillUpdateDialogAdditionalInfos.vue";
import Bill from "@/models/bill/Bill";
import {Permissions} from "@/helpers/constants";

@Component({
	components: {
		BillUpdateDialogAdditionalInfos, AsiCardDetailEntry, AsiCardDetail
	}
})
export default class BillCardAdditionalInfos extends Vue {

	@Prop({type: Object, default: null})
	public bill!: Bill | null;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get isBilling(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	@Emit('billChanged')
	public billChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}

}
